import React, { useState, useEffect, useRef } from 'react';
import './FloatingAddButton.css';
import { CurrencyDollarIcon, UserIcon } from '@heroicons/react/24/outline';

const FloatingAddButton = ({ onNuevoCliente, onNuevaVenta }) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  // Cerrar al hacer click fuera
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [isOpen]);

  const handleNuevaVenta = () => {
    setIsOpen(false);
    onNuevaVenta?.();
  };

  const handleNuevoCliente = () => {
    setIsOpen(false);
    onNuevoCliente?.();
  };

  return (
    <div ref={ref} className="floating-speed-dial">
      {/* Sub-botones (aparecen cuando está abierto) */}
      <div className={`floating-speed-dial__items${isOpen ? ' floating-speed-dial__items--open' : ''}`}>
        <button
          className="floating-sub-btn floating-sub-btn--green"
          onClick={handleNuevaVenta}
          aria-label="Nueva Venta"
        >
          <span className="sub-icon"><CurrencyDollarIcon className="w-4 h-4" /></span>
          <span className="sub-label">Nueva Venta</span>
        </button>
        <button
          className="floating-sub-btn floating-sub-btn--blue"
          onClick={handleNuevoCliente}
          aria-label="Nuevo Cliente"
        >
          <span className="sub-icon"><UserIcon className="w-4 h-4" /></span>
          <span className="sub-label">Nuevo Cliente</span>
        </button>
      </div>

      {/* Botón principal */}
      <button
        className={`floating-add-btn${isOpen ? ' floating-add-btn--open' : ''}`}
        onClick={() => setIsOpen((v) => !v)}
        aria-label={isOpen ? 'Cerrar menú' : 'Nuevo'}
        aria-expanded={isOpen}
      >
        <span className="plus">{isOpen ? '×' : '+'}</span>
        <span className="label">{isOpen ? 'Cerrar' : 'Nuevo'}</span>
      </button>
    </div>
  );
};

export default FloatingAddButton;
